// (Tema de Shopify: copia de tienda/prototipo/reyes.js con lo que se guarda en el pedido.)
// Página de los Reyes Magos: carta en vivo (escribe un Rey o los tres), lacre del color de quien firma
// y el mapa del viaje con la casa y la ciudad del peque.
(function () {
  "use strict";
  var T = window.Tienda, $ = T.$, $$ = T.$$, limpio = T.limpio;

  var REYES = {
    melchor: { nombre: "Melchor", color: "#8f1d2c" },
    gaspar: { nombre: "Gaspar", color: "#1d6b45" },
    baltasar: { nombre: "Baltasar", color: "#5b2a86" },
    tres: { nombre: "Melchor, Gaspar y Baltasar", color: "#a06c08" },
  };

  function nombre() { return limpio("#nombre") || (T.estado.genero === "nino" ? "Hugo" : "Lucía"); }
  function corona(color) { return '<svg style="color:' + color + '"><use href="#i-corona"/></svg>'; }

  function pintar(destacar) {
    var hl = function (t) { return T.hl(t, destacar); };
    var rey = REYES[T.estado.rey] || REYES.melchor, tres = T.estado.rey === "tres";
    var n = nombre(), ciudad = limpio("#ciudad"), logro = limpio("#logro"), regalo = limpio("#regalo");
    // yo / nosotros
    var v = tres
      ? { soy: "Somos Melchor, Gaspar y Baltasar, y te escribimos", recibi: "Hemos recibido tu carta: nos la ha traído un paje real y la hemos leído",
          entere: "Nos hemos enterado", se: "Sabemos", orgullo: "¡Qué orgullosos estamos de ti!", vi: "Hemos visto" }
      : { soy: "Soy " + rey.nombre + " y te escribo", recibi: "He recibido tu carta: me la ha traído un paje real y la he leído",
          entere: "Me he enterado", se: "Sé", orgullo: "¡Qué orgulloso estoy de ti!", vi: "He visto" };
    var p = [
      (T.estado.genero === "nino" ? "Querido " : "Querida ") + hl(n) + ":",
      v.soy + " desde el camino, a la luz de una hoguera, mientras los camellos descansan.",
      v.recibi + " despacito, junto al fuego.",
      (logro ? v.entere + " de que este año " + hl(logro) + ". " : v.se + " que este año te has esforzado mucho. ") + v.orgullo,
      (regalo ? v.vi + " que nos pides " + hl(regalo) + "; tu carta" : "Tu carta") + " viaja guardada en el cofre real.",
      "Todavía nos queda mucho camino desde Oriente hasta " + (ciudad ? hl(ciudad) : "tu casa") +
        ", pero no te preocupes: la estrella nos guía y llegaremos a tiempo, la noche del 5 de enero.",
    ];
    $("#carta").innerHTML = p.map(function (t) { return "<p>" + t + "</p>"; }).join("");
    $("#firma").textContent = rey.nombre;
    $(".vista .lacre").style.color = rey.color;
    $("#coronas-firma").innerHTML = tres
      ? corona(REYES.melchor.color) + corona(REYES.gaspar.color) + corona(REYES.baltasar.color)
      : corona(rey.color);

    // mapa del viaje y boceto del vídeo
    $("#viaje-casa").textContent = "Casa de " + (n.length > 14 ? n.slice(0, 13) + "…" : n);
    $("#viaje-ciudad").textContent = ciudad.length > 18 ? ciudad.slice(0, 17) + "…" : ciudad;
    $$(".nombre-vivo").forEach(function (s) { s.textContent = n; });
    $$(".ciudad-viva").forEach(function (s) { s.textContent = (ciudad || "Tu casa") + " →"; });
  }

  T.iniciar({
    pintar: pintar,
    tostada: function () { return "¡La carta real de " + limpio("#nombre") + " va en las alforjas!"; },
  });
})();
